module.exports = __webpack_public_path__ + "img/pegasus.54a4c913.png";